import type React from "react";
import { useEffect } from "react";

// Declare FRED global type
declare global {
  interface Window {
    FRED?: {
      init: (config: {
        locationId: string;
        perPage: number;
        layout: string;
        background: string;
        titleHexColor: string;
        starHexColor: string;
      }) => void;
    };
  }
}

const FRED_CONFIG = {
  locationId: "19aaf078-f5f8-4916-b86b-f8aacefec508",
  perPage: 5,
  layout: "carousel",
  background: "transparent",
  titleHexColor: "000000",
  starHexColor: "ffffff",
} as const;

const About: React.FC = () => {
  useEffect(() => {
    // FRED script is loaded in index.html
    // Just need to initialize once it's available
    const initFred = () => {
      if (window.FRED) {
        window.FRED.init(FRED_CONFIG);
      }
    };

    // Try immediately (script might already be loaded)
    initFred();

    // Also listen for script load in case it hasn't loaded yet
    const fredScript = document.querySelector(
      'script[src="https://d1yw3duy3i4qiv.cloudfront.net/js/sdk-v1.js"]',
    );
    if (fredScript) {
      fredScript.addEventListener("load", initFred);
    }

    return () => {
      if (fredScript) {
        fredScript.removeEventListener("load", initFred);
      }
    };
  }, []);

  return (
    <section
      className="py-12 md:py-16"
      style={{ backgroundColor: "var(--color-complementary)" }}
    >
      <div className="container mx-auto px-4">
        {/* Philosophy Section */}
        <div className="text-center mb-12 py-8 border-t border-b border-black/15 border-dashed">
          <p
            className="text-lg max-w-3xl mx-auto"
            style={{
              fontFamily: "'Petit Formal Script', script",
              fontSize: "1.5rem",
              color: "var(--color-text)",
            }}
          >
            Saskatoon's Boutique Indoor Cycling Studio offering ryhthm based classes for all levels.
          </p>
        </div>

        {/* Embrace Daily Moments Section */}
        <div className="mb-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center max-w-6xl mx-auto">
            {/* Image */}
            <div className="flex justify-center">
              <img
                src="/images/app.png"
                alt="Cycle Co App"
                className="max-w-md w-full"
              />
            </div>

            {/* Text and Buttons */}
            <div className="text-center lg:text-left">
              <h3
                className="text-2xl md:text-3xl font-bold mb-4"
                style={{ color: "var(--color-complementary)" }}
              >
                Embrace daily moments
              </h3>
              <p
                className="text-lg mb-6"
                style={{ color: "var(--color-text)" }}
              >
                Seamlessly book, manage, and explore classes on the Cycle Co
                app, or locate Cycle Co directly on MindBody.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <a
                  href="https://apps.apple.com/app/id6752277604"
                  className="px-6 py-3 rounded-lg font-semibold border-2 transition-all hover:scale-105"
                  style={{
                    borderColor: "var(--color-primary)",
                    color: "var(--color-text)",
                  }}
                >
                  Cycle Co App
                </a>
                <a
                  href="https://www.mindbodyonline.com/"
                  className="px-6 py-3 rounded-lg font-semibold border-2 transition-all hover:scale-105"
                  style={{
                    borderColor: "var(--color-primary)",
                    color: "var(--color-text)",
                  }}
                >
                  MindBody App
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* FRED Reviews Widget */}
        <div className="py-8">
          <div data-fred-widget-reviews className="max-w-6xl mx-auto" />
        </div>
      </div>
    </section>
  );
};

export default About;
